import {Component} from "@angular/core";
import {RouteHelper, RouteMapping} from "../misc/route-helper";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {SandyBreadcrumbItemModel, SandyService} from "./sandy.service";

@Component({
  templateUrl: "./sandy-import-page.template.pug",
  providers: [SandyService],
})
export class SandyAssetInfoImportComponent extends RouteHelper {
  error: Error;
  projectId: string;
  siteId: string;
  orderId: string;

  entityId: string;
  entityParam: string;
  entityName: string;
  breadcrumbs: SandyBreadcrumbItemModel[];

  paramsMap: RouteMapping[] = [
    {fieldName: "projectId", paramName: "projectId"} as RouteMapping,
    {fieldName: "siteId", paramName: "siteId"} as RouteMapping,
    {fieldName: "orderId", paramName: "orderId"} as RouteMapping,
  ];

  async loadData() {
    this.error = undefined;

    if (this.orderId) {
      this.entityId = this.orderId;
      this.entityParam = "orderId";
      this.entityName = "Order";
    } else if (this.siteId) {
      this.entityId = this.siteId;
      this.entityParam = "siteId";
      this.entityName = "Site";
    } else if (this.projectId) {
      this.entityId = this.projectId;
      this.entityParam = "projectId";
      this.entityName = "Project";
    }

    const breadcrumbData = await this.sandyService.getSandyBreadcrumbs(this.entityId, this.entityParam);
    this.breadcrumbs = breadcrumbData;
    const current = breadcrumbData.find(it => it.queryAction === this.entityName.toLowerCase());
    if (current) this.entityName = `${this.entityName}: ${current.text}`;
  }

  navigate(queryParams: Params, skipLocationChange: boolean = false): Promise<boolean> {
    return this.router.navigate(["project"], {queryParams, skipLocationChange});
  }

  handleError(event) {
    this.error = event["error"];
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private sandyService: SandyService,
  ) {
    super();
  }
}
